import { Div, Snack, TextInput, NumberInput } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { ProductSelector } from "../Components/ProductSelector";
import { DateSlider } from "../Components/Utils/DateSlider";
import { Icons } from "../Components/Utils/Icons";
import { TabsV2 } from "../Components/Utils/Tabs";
import { DefaultButton, XPrimaryButton } from "../Components/Utils/XPrimaryButton";
import { BasketItem } from "../Models/Basket/BasketItem";
import { RentBasketItem } from "../Models/Basket/RentBasketItem";
import { SaleBasketItem } from "../Models/Basket/SaleBasketItem";
import { DateTimeProvider } from "../Services/DateTimeProvider";
import { SpecteamShopContentProvider } from "../Services/SpecteamShopContentProvider";
import { RawProductInfo } from "../Models/Basket/Product";
import { ProductOption } from "../Models/Basket/ProductOption";


export class BasketItemBuilder extends Div
{
    constructor(private _shop: SpecteamShopContentProvider, private onAdd: (item?: BasketItem) => void)
    {
        super("");
    }

    async OnAppend()
    {
        const shop = await this._shop.Get();
        if (!shop)
        {
            this.Append(new Snack("Brak danych sklepu", "Czy plik na pewno jest na serwerze?", { autoCloseTimeout: 0 }));
            return;
        }

        this.Append(
            new DefaultButton("Anuluj", Icons.Trash, () => this.onAdd(undefined)),
            new TabsV2()
                .Add(Icons.Plus, "Wynajem", () =>
                {
                    const rentItem = new RentBasketItem({
                        ProductInfo: { Id: shop.Products[0].Id } as RawProductInfo,
                        Option: { Id: shop.Products[0].Options.List[0].Url } as ProductOption
                    });
                    return new Table([], [
                        ["Produkt", new ProductSelector(shop.Products, rentItem)],
                        ["Początek", new DateSlider(rentItem.From, () => DateTimeProvider.Now)],
                        ["Koniec", new DateSlider(rentItem.To, () => DateTimeProvider.Now)],
                        ["Numer seryjny", new TextInput(rentItem.ProductSerialNumber)],
                        ["Ilość", new NumberInput(rentItem.Quantity)],
                        ["Cena", new NumberInput(rentItem.TotalPrice)],
                        ["Kaucja", new NumberInput(rentItem.Deposit)],
                        ["", new XPrimaryButton("Dodaj do koszyka", Icons.Plus, () => this.onAdd(new RentBasketItem(rentItem.AsRaw)))],
                    ]);
                })
                .Add(Icons.Plus, "Sprzedaż", () =>
                {
                    const saleItem = new SaleBasketItem({});
                    return new Table([], [
                        ["Produkt", new ProductSelector(shop.Products, saleItem)],
                        ["Numer seryjny", new TextInput(saleItem.ProductSerialNumber)],
                        ["Ilość", new NumberInput(saleItem.Quantity)],
                        ["Cena", new NumberInput(saleItem.TotalPrice)],
                        ["", new XPrimaryButton("Dodaj do koszyka", Icons.Plus, () => this.onAdd(new SaleBasketItem(saleItem.AsRaw)))],
                    ]);
                }),
        );
    }
}
